import {AuthType, ErrorCode, headerNames, queryStrings, urls} from '../constants';
import {log} from '../shared/log';

const queryString = require('query-string');

const currentParams = queryString.parse(location.search);

let pendingAuth: string;

export interface SnapAuth {
  isAuthException(ex: any): ex is SnapAuthException;
  signIn(authType: AuthType, data?: {}): Promise<Response>;
  signUp(authType: AuthType, data?: {}): Promise<Response>;
  setPendingAuth(value: string): void;
}

export class SnapAuthException {
  constructor(
    public message: string,
    public controls: Map<string, string> = new Map(),
    public code = ErrorCode.Unknown,
    public response: Response | null = null,
  ) {}
}

export function isAuthException(ex: any): ex is SnapAuthException {
  return ex instanceof SnapAuthException;
}

export function setPendingAuth(value: string) {
  pendingAuth = value;
}

export async function signIn(authType: AuthType, data?: {}) {
  const headers: any = {[headerNames.AUTH_TYPE]: authType};

  if (pendingAuth) {
    headers[headerNames.PENDING_AUTH] = pendingAuth;
  }

  const returnUrl = currentParams[queryStrings.RETURN_URL];
  if (returnUrl) {
    headers[headerNames.REDIRECT_URL] = returnUrl;
  }

  const response = await sendRequest(urls.SNAP_SIGNIN, data, headers);

  if (response.ok) {
    return response;
  }

  switch (response.status) {
    case 422:
      const body = await response.json();
      throw new SnapAuthException(body.message, mapDetails(body.details), body.code, response);
    default:
      throw unknownError(`Unexpected http response (${response.status}) ${await response.text()}`);
  }
}

export async function signUp(authType: AuthType, data?: {}) {
  const url = attachReferrer(urls.SNAP_SIGNUP);
  const headers: any = {[headerNames.AUTH_TYPE]: authType};

  const ignoreWorkflow = queryStrings.IGNORE_WORKFLOW in currentParams;
  const returnUrl = currentParams[queryStrings.RETURN_URL];

  if (ignoreWorkflow && returnUrl) {
    headers[headerNames.REDIRECT_URL] = returnUrl;
  }

  const response = await sendRequest(url, data, headers);

  if (response.ok) {
    return response;
  }

  switch (response.status) {
    case 422:
    case 409:
      const body = await response.json();
      throw new SnapAuthException(body.message, mapDetails(body.details), body.code, response);
    default:
      throw unknownError(`Unexpected http response (${response.status}) ${await response.text()}`);
  }
}

function attachReferrer(url: string) {
  const referrer = getReferrer();
  if (!referrer) {
    return url;
  }

  const param = queryString.stringify({[queryStrings.REFERRER]: referrer});
  const queryDelimiter = url.indexOf('?') > -1 ? '&' : '?';
  return `${url}${queryDelimiter}${param}`;
}

function getReferrer() {
  let referrer = currentParams[queryStrings.REFERRER];
  if (Array.isArray(referrer)) {
    referrer = referrer[0];
  }
  return typeof referrer === 'string' ? referrer.trim() || undefined : undefined;
}

function mapDetails(details: Array<{key: string, message: string}>) {
  if (!Array.isArray(details)) {
    return;
  }

  return new Map(details.map(({key, message}) => [key, message] as [string, string]));
}

async function sendRequest(url: string, data?: {}, headers = {}) {
  try {
    return await fetch(url, {
      credentials: 'include',
      method: 'post',
      headers: new Headers({'Content-Type': 'application/json', ...headers}),
      body: JSON.stringify(data),
    });
  } catch (ex) {
    throw unknownError(ex);
  }
}

function unknownError(message: string) {
  log.sendError(message);
  return new SnapAuthException(`Can't sign in`);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/core/snap-auth.ts